import WdLoading from '@main/core/WdLoading';
import { Navigate } from 'react-router-dom';
import { generateRoutesFromAsyncList, setRoutes } from '@main/utils/resolvers';
import {
  AdminConfig,
  ProfileConfig,
  BillingConfig,
  CompaniesConfig,
  DashboardConfig,
  Error404Page,
  ErrorPage,
  KiosksConfig,
  LocationsConfig,
  SetupConfig,
  SignInConfig,
  SignOutConfig,
  SignUpConfig,
  StripeConfig,
  TurnstilesConfig,
  UserRegistersConfig,
  SignValidateConfig,
  SignRecoveryConfig,
  RecognitionConfig,
} from '../views';

const disableDecorations = {
  settings: {
    layout: {
      config: {
        navbar: {
          display: false,
        },
        toolbar: {
          display: false,
        },
        footer: {
          display: false,
        },
        leftSidePanel: {
          display: false,
        },
        rightSidePanel: {
          display: false,
        },
      },
    },
  },
};

// ---- Rutas base pueden acceder con o sin autenticación
export const staticRoutes = [
  {
    path: 'loading',
    element: <WdLoading />,
  },
  {
    path: '404',
    element: <Error404Page />,
    ...disableDecorations,
  },
  {
    path: 'error',
    element: <ErrorPage />,
    ...disableDecorations,
  },
  {
    path: '*',
    element: <Navigate to="/404" />,
  },
  // Rutas que seran estaticas publicas y no entraran en el filtrado por scopes ni por modules
  ...setRoutes(SignInConfig),
  ...setRoutes(SignUpConfig),
  ...setRoutes(SignRecoveryConfig),
  ...setRoutes(SignValidateConfig),
  ...setRoutes(SignOutConfig),
];

// ---- Aqui se agregan las rutas que se vayan requiriendo en la app --------
const mergedRoutes = [
  // ===== Rutas publicas ========
  // ===== Rutas protegidas básicas ========
  DashboardConfig,
  ProfileConfig,
  AdminConfig,
  CompaniesConfig,
  StripeConfig,
  BillingConfig,
  LocationsConfig,
  KiosksConfig,
  TurnstilesConfig,
  UserRegistersConfig,
  SetupConfig,
  RecognitionConfig,
];

// ------ Exporta rutas al contexto global de la App -------------
export const asyncRoutes = [...generateRoutesFromAsyncList(mergedRoutes), ...mergedRoutes];

// ----- Rutas asicronas con comportamiento de acceso publico pero con filtro de scopes/modulos activo ------------
export const whiteList = [];
